<template>
  <div class="">
    <div class="index_main">
      <div class="app_centent">
        <div v-for="(item,index) in list" :key="index" class="centent_list" @click="handleUpdate(item.id)">
          <div class="list_label">
            <span v-if="item.category_id==19">现场专业人员</span>
            <span v-else>暂无分类</span>
          </div>
          <div class="list_img">
            <el-image :src="item.images_url" lazy fit="cover" style="width: 100%;height: 140px">
              <div slot="placeholder" class="image-slot">
                加载中<span class="dot">...</span>
              </div>
            </el-image>
          </div>
          <div class="list_model">
            <div class="desc">{{ item.name }}</div>
            <div class="level">课时 {{item.studyHours}}时   .    学习人数 {{item.num==null?0:item.num}}人</div>
            <div class="inst">{{item.inst_name}}</div>
            <div class="price">
              <div class="rate">
                <template v-if="item.grade>0">
                  <el-rate disabled v-model="item.grade"></el-rate>
                </template>
                <template v-else>
                  <div class="no_rate">暂无评分</div>
                </template>
              </div>
<!--              <div class="price_name" @click.stop="toggleWaiting(item)">加入待选</div>-->
              <div class="price_name">查看详情</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Utils from '@/utils/transfer.js'
  import {mapGetters} from "vuex";
    export default {
        props:{
            list:{
                type:Array,
                default:[]
            }
        },
        computed:{
            ...mapGetters(['userinfo'])
        },
        watch:{
            list(n,v){
                this.list = n
            }
        },
        name: "Index",
        data(){
            return{

            }
        },
        created() {
            let user = JSON.parse(this.userinfo)
            this.user = user
        },
        methods:{
            handleUpdate(id){
                this.$router.push({path: '/newCourse/details',query:{id}})
            },
            toggleWaiting(item){
                //待选功能先关闭。
                return;
                if(this.user==null){
                    this.$message({
                        message: '请先登录哦～',
                        type: 'warning'
                    });
                    return;
                }
                let goods = JSON.parse(localStorage.getItem('goods'));
                if(goods==null){
                    let goods = []
                    goods.unshift(item)
                    localStorage.setItem('goods', JSON.stringify(goods))
                    this.$message({
                        message: '已加入待选课程',
                        type: 'success'
                    });
                    Utils.$emit('trade','更新');
                }
                if(goods!=null){
                    //判断当前课程是否已加入  根据id
                    for (var i=0;i<goods.length;i++){
                        if(goods[i].id==item['id']){
                            this.$message({
                                message: '当前课程已经加入了哦，不用重复添加',
                                type: 'warning'
                            });
                            return
                        }
                    }
                    goods.unshift(item)
                    localStorage.setItem('goods', JSON.stringify(goods))
                    this.$message({
                        message: '已加入待选课程',
                        type: 'success'
                    });
                    Utils.$emit('trade','更新');
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
.index{
  .index_main{
    flex-direction: row;
    flex-wrap: wrap;
    width: 1200px;
    .app_centent{
      min-height: 300px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      margin: 30px auto;
      .centent_list{
        border-radius: 10px;
        overflow: hidden;
        width: 285px;
        height: 280px;
        box-shadow: 0 6px 10px 0 #eff0f1;
        margin-right: 20px;
        margin-bottom: 30px;
        cursor: pointer;
        position: relative;
        background-color: #fff;
        &:nth-child(4n){
          margin-right: 0;
        }
        &:hover{
          margin-top: -4px;
          transition: all .2s linear;
          box-shadow:0 0 15px #bbbbbb;
        }
        .list_label{
          position: absolute;
          right: 0;
          top: 0;
          padding: 0 8px;
          height: 28px;
          font-weight: bold;
          line-height: 28px;
          text-align: center;
          color: #fff;
          font-size: 12px;
          background-color: #e78021;
          border-radius: 0 0 0 15px;
          z-index: 10;
        }
        .list_img{
          width: 100%;
          height: 140px;
          overflow: hidden;
          .image-slot{
            text-align: center;
            height: 140px;
            line-height: 140px;
            background-color: #eee;
          }
          img{
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .list_model{
          padding: 10px;
          .desc{
            font-size: 14px;
            color: #545C63;
            height: 40px;
            overflow: hidden;
            word-break: break-all;  /* break-all(允许在单词内换行。) */
            text-overflow: ellipsis;  /* 超出部分省略号 */
            display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
            -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
            -webkit-line-clamp: 2; /** 显示的行数 **/
          }
          .level{
            font-size: 12px;
            color: #9199a1;
            padding: 8px 0;
          }
          .inst{
            font-size: 12px;
            color: #e6a23c;
            padding: 4px 0;
          }
          .price{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            .price_name{
              width: 85px;
              height: 28px;
              line-height: 28px;
              background-color: #3ab06f;
              color: #fff;
              border-radius: 5px;
              font-size: 12px;
              text-align: center;
              cursor: pointer;
              &:hover{
                opacity: 0.7;
              }
            }
            .rate{
              /deep/ .el-rate__icon{
                margin-right: -3px !important;
              }
              .no_rate{
                color: #999;
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
</style>